import $ from "cash-dom";

export default (function () {
    $(document).ready(function () {
        var log = typeof debug !== "undefined";
        if (log) console.log("%cfunction_cover.js initialized", "color: green;");

        var selector = ".cover";

        function cover() {
            $(selector).each(function () {
                var instance = $(this).is("lottie-player") ? $($(this)[0].shadowRoot).find("#animation") : $(this);
                var parent = $(this).parent();
                var instanceRatio = instance.width() / instance.height();
                var parentRatio = parent.width() / parent.height();

                instanceRatio = Math.ceil(instanceRatio * 100) / 100;
                parentRatio = Math.ceil(parentRatio * 100) / 100;

                if (instanceRatio < parentRatio) {
                    $(this).css({ width: "100%", height: "auto" });
                }

                if (instanceRatio > parentRatio) {
                    $(this).css({ width: "auto", height: "100%" });
                }
            });
        }

        cover();
        $(window).on("resizeEnd fetchSuccess moduleLoad", cover);
    });
})();
